import React from 'react';
import { ButtonBase, makeStyles, Snackbar } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiSnackbarContent-root': {
      backgroundColor: '#FF655C',
      fontSize: '1rem',
      color: '#FFF',
      fontFamily: 'NotoSans-Medium',
      padding: '1.63rem 2.25rem',
      flexWrap: 'unset',
    },
    '& .MuiSnackbarContent-action': {
      margin: 'unset',
      padding: 'unset',
    },
  },
  button: {
    marginLeft: '2.5rem',
    borderRadius: '8px',
    backgroundColor: '#FFF',
    border: '1px solid #538FFF',
    fontSize: '1rem',
    color: '#538FFF',
    fontFamily: 'NotoSans-Medium',
    width: '12.5rem',
    height: '3rem',
  },
}));

const AlertConfirm = ({ onClose }) => {
  const classes = useStyles();
  return (
    <Snackbar
      className={classes.root}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={true}
      message={`This patient's ID/Doc#starts with "UL". Kindly check carefully`}
      action={
        <ButtonBase className={classes.button} onClick={onClose}>
          Confirm
        </ButtonBase>
      }
    />
  );
};

export default AlertConfirm;
